<common-mojo-card>
  <div class="phases-carousel-wrapper">
    <div
      class="phases-carousel w-100"
      #carouselContainer
    >
      <mat-tab-group class="phases-carousel">
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="carousel-cell-main">
              <ng-container
                *ngTemplateOutlet="carouselElement; context: {totalNumber: directApplicantsTotal$ | async, phaseName: directApplicantsLabel}"
              ></ng-container>
            </div>
          </ng-template>
        </mat-tab>

        <mat-tab *ngFor="let phase of (phases$ | async)">
          <ng-template mat-tab-label>
            <div class="carousel-cell">
              <ng-container
                *ngTemplateOutlet="carouselElement; context: {totalNumber: phase.numberOfDirectApplicants, phaseName: phase.phase}"
              ></ng-container>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</common-mojo-card>

<ng-template
  #carouselElement
  let-totalNumber="totalNumber"
  let-phaseName="phaseName"
>
  <mojo-number-presenter-v2
    *ngIf="(phaseName === directApplicantsLabel) || !enableLinks"
    [number]="totalNumber"
    [label]="phaseName"
    [mainNumber]="true"
    (click)="changeStatus(phaseName)"
  ></mojo-number-presenter-v2>
  <mojo-number-presenter-v2
    *ngIf="(phaseName !== directApplicantsLabel) && enableLinks"
    [routerLink]="['/jobs', 'job', _jobId, shortlist]"
    [queryParams]="getShortlistedParams(phaseName)"
    [number]="totalNumber"
    [label]="phaseName"
    [mainNumber]="true"
  ></mojo-number-presenter-v2>
</ng-template>
